import { Home } from '../../../@core/models/home';
import { GeneralService } from '../../../@core/data/general.service';
import { StorageService } from '../../../@core/data/storage.service';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'edm-reminder-app',
  templateUrl: './reminder-app.component.html',
  styleUrls: ['./reminder-app.component.scss'],
  standalone: false,
})

export class ReminderAppComponent {

  showModal: boolean = false;
  intervalDays: number = 7;

  imageDownloadAppleStore: string = "/assets/images/img-download-apple.webp";
  imageDownloadGoogleStore: string = "/assets/images/img-download-google.webp";

  linkFirebaseStore: string = "";
  linkAppleStore: string = "";
  linkGoogleStore: string = "";

  nameProj: string = "";

  isMobile: boolean = false;
  pathBaseTranslate: string = 'theme.components.header.reminder-app.';

  constructor(
    private storageService: StorageService,
    private generalService: GeneralService,
  ) {
    this.nameProj = environment.appname.toLowerCase().replace(/\s/g, '');
    this.isMobile = window.innerWidth <= 1023;
    this.loadData();
  }

  private verifyReminder(): void {
    let dateRemimber = this.storageService.restore(this.nameProj + '-remimber-app-data');
    if (dateRemimber && dateRemimber.length > 3) {
      let dateNow = new Date();
      let dateRemInt = new Date(parseInt(dateRemimber));
      dateRemInt.setDate(dateRemInt.getDate() + this.intervalDays);
      if (dateNow > dateRemInt) {
        this.showModal = true;
      }
    } else {
      this.showModal = true;
    }
  }

  private loadData(): void {
    this.generalService.home$.subscribe((home: Home): void => {
      if (home !== null && home !== undefined) {

        this.linkAppleStore = home.ios_url;
        this.linkGoogleStore = home.android_url;
        this.verifyReminder();

        if(this.isIOS()){
          this.linkFirebaseStore = home.ios_url;
          return
        }

        if(this.isAndroid()){
          this.linkFirebaseStore = home.android_url;
          return
        }
      }
    });
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  verifyLink(link: string): boolean {
    if (link !== null && link !== undefined && typeof(link) === "string" && link.trim().length > 3) {
      return true;
    }
    return false;
  }

  setDateToday(): void {
    this.showModal = false;
    let timeElapsed = Date.now().toString();
    this.storageService.store(timeElapsed, this.nameProj + '-remimber-app-data');
  }

  isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  isAndroid(): boolean {
    return /android/i.test(navigator.userAgent);
  }
}
